import React from 'react';
import { useTranslation } from 'react-i18next';

function NotFound() {
    const { t } = useTranslation();
    return <div className="alert alert-danger">{t('error_hint.not_found_address')}</div>;
}

export default NotFound;
